var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{attrs:{"name":"modal"}})],1),_c('transition',{attrs:{"name":"fade"}},[_c(_vm.modalName,{tag:"component"})],1),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }